import * as types from "../ActionType";

const initState = {
    allreviwes: [],
    loadingallreviwes: true,
    allReels: [],
    loadingAllReels: true
}

const ReviewsReducer = (state = initState, action) => {
    switch (action.type) {
        case types.GET_ALL_REVIEWS:
            return { ...state, allreviwes: action.payload, loadingallreviwes: false }
        case types.EDIT_STATUS_REVIEWS:
            return { ...state, loadingallreviwes: true }
        case types.DELETE_REVIEW:
            return { ...state, loadingallreviwes: true }
        case types.GET_ALL_REELS:
            return { ...state, allReels: action.payload, loadingAllReels: false }
        case types.ADD_REELS:
            return { ...state, loadingAllReels: true }
        case types.DELETE_REELS:
            return { ...state, loadingAllReels: true }
        default:
            return state;
    }
};

export default ReviewsReducer;
